import { apiFetch, apiFetchFormData } from './client';

export const calendarAPI = {
  create: (data) =>
      apiFetch('/calendars', { method: 'POST', body: JSON.stringify(data) }),

  list: (accountId) =>
      apiFetch(`/calendars?accountId=${accountId}`),

  getById: (id) =>
      apiFetch(`/calendars/${id}`),

  update: (id, data) =>
      apiFetch(`/calendars/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  delete: (id) =>
      apiFetch(`/calendars/${id}`, { method: 'DELETE' }),

  updatePost: (calId, postId, data) =>
      apiFetch(`/calendars/${calId}/posts/${postId}`, { method: 'PUT', body: JSON.stringify(data) }),

  generate: (id) =>
      apiFetch(`/calendars/${id}/generate`, { method: 'POST' }),

  regeneratePost: (calId, postId, body = {}) =>
      apiFetch(`/calendars/${calId}/posts/${postId}/regenerate`, { method: 'POST', body: JSON.stringify(body) }),

  confirmPost: (calId, postId) =>
      apiFetch(`/calendars/${calId}/posts/${postId}/confirm`, { method: 'POST' }),

  confirmAll: (id) =>
      apiFetch(`/calendars/${id}/confirm-all`, { method: 'POST' }),

  generateImages: (id) =>
      apiFetch(`/calendars/${id}/generate-images`, { method: 'POST' }),

  convert: (id) =>
      apiFetch(`/calendars/${id}/convert`, { method: 'POST' }),

  toggleAutoSchedule: (id, enabled) =>
      apiFetch(`/calendars/${id}/auto-schedule`, { method: 'PUT', body: JSON.stringify({ enabled }) }),

  // 이미지 관리
  generatePostImage: (calId, postId, data = {}) =>
      apiFetch(`/calendars/${calId}/posts/${postId}/images/generate`, { method: 'POST', body: JSON.stringify(data) }),

  deletePostImage: (calId, postId, imageId) =>
      apiFetch(`/calendars/${calId}/posts/${postId}/images/${imageId}`, { method: 'DELETE' }),

  reorderPostImages: (calId, postId, imageIds) =>
      apiFetch(`/calendars/${calId}/posts/${postId}/images/reorder`, { method: 'PUT', body: JSON.stringify({ imageIds }) }),

  uploadPostMedia: (calId, postId, file) =>
      apiFetchFormData(`/calendars/${calId}/posts/${postId}/images/upload`, file),

  replacePostMedia: (calId, postId, mediaId, file) =>
      apiFetchFormData(`/calendars/${calId}/posts/${postId}/images/${mediaId}/replace`, file, 'PUT'),

  // 수동 인스타그램 업로드
  publishToInstagram: (postId) =>
      apiFetch(`/calendars/posts/${postId}/publish`, { method: 'POST' }),
};
